import ClienteTelefoneService from "@/services/ClienteTelefoneService";

export const clienteTelefone = {
  namespaced: true,
  state: {
    clienteTelefone: {},
  },
  actions: {
    getClienteTelefone({ commit }, payload) {
      return ClienteTelefoneService.GetClienteTelefone(payload).then(
        (clienteTelefone) => {
          return Promise.resolve(clienteTelefone);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postClienteTelefone({ commit }, payload) {
      return ClienteTelefoneService.PostClienteTelefone(payload).then(
        (clienteTelefone) => {
          return Promise.resolve(clienteTelefone);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putClienteTelefone({ commit }, payload) {
      return ClienteTelefoneService.PutClienteTelefone(payload).then(
        (clienteTelefone) => {
          return Promise.resolve(clienteTelefone);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteClienteTelefone({ commit }, payload) {
      return ClienteTelefoneService.DeleteClienteTelefone(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getClienteTelefoneOData({ commit }, payload) {
      return ClienteTelefoneService.GetClienteTelefoneOData(payload).then(
        (clienteTelefone) => {
          return Promise.resolve(clienteTelefone);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default clienteTelefone;
